import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

/** Hard-delete user with confirmation. Hidden when viewing self. */
export default function DrawerDangerZone({ user, onDeleted }) {
  const [busy, setBusy] = useState(false);

  const deleteUser = async () => {
    if (!window.confirm(
      `Delete ${user.email}? This removes the account and any linked roster/certifications.`
    )) return;
    setBusy(true);
    try {
      await api.delete(`/owner/users/${user.id}`);
      toast.success("User deleted");
      onDeleted();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <div className="px-5 py-5 border-t-2" style={{ borderTopColor: "rgba(249,215,28,0.3)" }}>
      <div className="flex items-center gap-2 mb-2">
        <Trash2 className="w-4 h-4 text-status-expired" strokeWidth={3} />
        <h3 className="font-heading text-lg text-status-expired">DANGER ZONE</h3>
      </div>
      <p className="text-xs text-white/60 mb-3">
        Permanently delete this account, its roster record and all certifications.
      </p>
      <button
        data-testid="delete-user"
        onClick={deleteUser}
        disabled={busy}
        className="w-full h-11 inline-flex items-center justify-center gap-2 bg-status-expired text-white border-2 border-status-expired font-bold uppercase tracking-wider text-xs hover:opacity-90 disabled:opacity-60"
      >
        <Trash2 className="w-3.5 h-3.5" strokeWidth={3} />
        {busy ? "Deleting…" : "Delete User"}
      </button>
    </div>
  );
}
